import type React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import type { TruckGroup } from "../../types/truckGroup";
import { colors } from "../../constants/colors";

interface TruckGroupAboutModalProps {
  open: boolean;
  onClose: () => void;
  currentGroup?: TruckGroup;
}

const TruckGroupAboutModal: React.FC<TruckGroupAboutModalProps> = ({
  open,
  onClose,
  currentGroup,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          boxShadow: colors.shadow.light.medium,
        },
      }}
    >
      <DialogTitle
        sx={{
          pt: 4,
          px: 3,
          pb: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            color: theme.palette.text.primary,
          }}
        >
          {t("About TruckGroup")}
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          px: 3,
          pt: 3,
          pb: 3,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary,
            lineHeight: 1.7,
            fontSize: "0.95rem",
          }}
        >
          {t("TruckGroup.about")}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          py: 2,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            px: 3,
            py: 1,
            borderColor: theme.palette.divider,
            color: theme.palette.text.primary,
            "&:hover": {
              borderColor: theme.palette.primary.main,
              backgroundColor: "transparent",
            },
          }}
        >
          {t("Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TruckGroupAboutModal;
